import React from "react";
import "../styles/SignIn.css";
import Navbar from "../components/Navbar";
import SignInForm from "../components/SignIn/SignInForm";

function SignIn() {
  return (
    <div className="sign-in-page">
      <Navbar />
      <div className="sign-in-content">
        <SignInForm />
      </div>
    </div>
  );
}

export default SignIn;
